import type { IconNode } from '../types';

/**
 * @name saudi-riyal
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMi45Nzd2MTMuMTlhMiAyIDAgMDEtMS4yMyAxLjg0Nkw0IDE5Ljk5OSIgLz4KICA8cGF0aCBkPSJNMTQgNHY5LjUyM2ExIDEgMCAwMDEuMzcxLjkyOEwxOSAxMyIgLz4KICA8cGF0aCBkPSJtMTkgMTgtNSAyIiAvPgogIDxwYXRoIGQ9Ik0xOSA4IDQgMTQiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/saudi-riyal
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const SaudiRiyal: IconNode = [
  ['path', { d: 'M10 2.977v13.19a2 2 0 01-1.23 1.846L4 19.999' }],
  ['path', { d: 'M14 4v9.523a1 1 0 001.371.928L19 13' }],
  ['path', { d: 'm19 18-5 2' }],
  ['path', { d: 'M19 8 4 14' }],
];

export default SaudiRiyal;
